import * as Sentry from "@sentry/react";
import { createBrowserRouter } from "react-router";
import { adminRoutes } from "@/src/admin/navigations/admin-router";
import { aiRoutes } from "@/src/ai/navigations/ai-router";
import { authRoutes } from "@/src/auth/navigations/auth-router";
import { COMMON_ROUTES } from "@/src/common/constants/common-routes";
import { RootLayout } from "@/src/common/layouts/root-layout";
import { RootRedirect } from "@/src/common/navigations/root-redirect";
import CommunityNotFoundPage from "@/src/common/pages/community-not-found-page";
import NotFoundPage from "@/src/common/pages/not-found-page";
import { contactRoutes } from "@/src/contact/navigations/contact-router";
import { emailRoutes } from "@/src/email/navigations/email-router";
import { eventPublicRoutes, eventRoutes } from "@/src/event/navigations/event-router";
import { externalInvitationRoutes } from "@/src/external-invitation/navigations/external-invitation-router";
import { groupRoutes } from "@/src/group/navigations/group-router";
import { legalRoutes } from "@/src/legal/navigations/legal-router";
import { meetingPublicRoutes, meetingRoutes } from "@/src/meeting/navigations/meeting-router";
import { memberRoutes } from "@/src/member/navigations/member-router";
import { messageRoutes } from "@/src/message/navigations/message-router";
import { moderationRoutes } from "@/src/moderation/navigations/moderation-router";
import { notificationRoutes } from "@/src/notification/navigations/notification-router";
import { onboardingRoutes } from "@/src/onboarding/navigations/onboarding-router";
import { postRoutes } from "@/src/post/navigations/post-router";
import { AppRouteLayout } from "@/src/shell/layouts/app-route-layout";
import { staffRoutes } from "@/src/staff/navigations/staff-router";
import { videoRoutes } from "@/src/video/navigations/video-router";

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

export const rootRouter = sentryCreateBrowserRouter([
	{
		element: <RootLayout />,
		children: [
			legalRoutes,
			contactRoutes,
			authRoutes,
			onboardingRoutes,
			videoRoutes,
			staffRoutes,
			externalInvitationRoutes,
			emailRoutes,
			eventPublicRoutes,
			meetingPublicRoutes,
			{
				element: <AppRouteLayout />,
				children: [
					postRoutes,
					memberRoutes,
					groupRoutes,
					messageRoutes,
					meetingRoutes,
					eventRoutes,
					moderationRoutes,
					notificationRoutes,
					adminRoutes,
					aiRoutes,
				],
			},
			{ path: "/", element: <RootRedirect /> },
			{ path: COMMON_ROUTES.COMMUNITY_NOT_FOUND, element: <CommunityNotFoundPage /> },
			{ path: "*", element: <NotFoundPage /> },
		],
	},
]);
